import { ResourceKey } from 'i18next'

const translation: ResourceKey = {
  "pt-BR": {
    translation: {
      haveAnAccount: 'Já possui uma conta?',
      signIn: "Entrar",
      loginText: "Insira seu login e senha para entrar.",
      login: 'Login',
      password: 'Senha',
      confirmPassword: 'Confirmar senha',
      forgotPassword: 'Esqueci minha senha',
      signInGoogle: 'Entrar com Google',
      signInFacebook: 'Entrar com Facebook',
      noAccount: 'Não possui conta?',
      createNow: 'Criar agora',
      portuguese: 'Português',
      english: 'Inglês',
      or: 'ou',
      passwordPlaceholder: 'Insira a senha',
      loginPlaceholder: 'CPF',
      wrongUsernameOrPassword: 'Usuário ou senha incorreto',

      forgotPasswordText: 'Insira seu documento para receber um token de acesso.',
      sendToken: 'Enviar token',
      helpText1: 'Problemas para acessar? Abra o ',
      chat: 'chat ',
      helpText2: 'para falar com nosso atendimento ou fale por WhatsApp ',
      insertCodeSentTo: 'Digite o código enviado para ',
      confirm: 'Confirmar',

      reSendCode: 'Re-enviar código',
      sendViaEmail: 'Enviar para email',

      hi: 'Olá, ',
      access: 'Acesso ao laudo',

      changeDocument: 'Alterar documento',
      SelectDocument: 'Selecione um documento',
      document: 'Documento',
      createPassword: 'Crie uma nova senha',
      resetPassword: 'Redefinir senha',

      documentnotfind: 'Não encontramos o documento informado!',
      resetPasswordSuccess: 'Senha alterada com sucesso',
      resetPasswordError: 'Houve um erro ao cadastrar a nova senha!',
      helperNewPassword: 'Crie uma senha de 6 a 15 caracteres. A senha não pode ser igual ao número do seu documento.',
      accept: 'Aceito os ',
      termsofuse: 'Termos de Uso',
      and: ' e ',
      privacy: 'Política de Privacidade.',

      "cpf is not valid": "Cpf inválido",
      "no password provided": "Senha é um campo obrigatório",
      "User not found": "Usuário não encontrado",
      "Bad credentials": "Código inválido ou expirado.",
      'token is required': "Código é obrigatório",
      'Password is required': 'Senha é obrigatório',
      'Confirm password is required': 'Confirmação de senha é obrigatório',
      'required field': 'Este campo é obrigatório',


      'PIN submission failed': 'Ocorreu um erro ao enviar o código!',
      'Password does not match': 'As senhas não coincidem',
      'the password provided cannot be the same as the document number.': 'A senha fornecida não pode ser igual ao número do documento.',
      'token generation failed': 'Houve um erro ao gerar o token',

      'the field new password - min 6 and max 15 characters': 'A senha excedeu o limite maximo/minimo de caracter. Tente de novo!',
      'the new password field cannot be empty': 'A senha não pode ser vazio',

      espanish: 'Espanhol',
      resentPINToken: 'O código foi reenviado, confira a sua caixa de entrada de E-mail e SMS ',
      birthCertificate: 'Certidão de nascimento',
      foreignDocument: 'Documento estrangeiro',
      errorCertificate: 'O documento inserido não é válido ou não está cadastrado em nosso banco de dados. Apenas certidões emitidas após 2010 são aceitas como login.',
      documentInvalid: 'O documento inserido não é válido',
      /* finish example block */

      /* Text report sms */

      seeResults: 'Ver meu resultado',

      registerDocument: 'Insira o documento cadastrado no momento do exame.',
      expireLink: 'Por segurança, este link expira 24h após a emissão do laudo. Após este período, acesse o Portal do Paciente ou baixe o aplicativo Hilab para visualizar todos os seus exames.',
      nDocument: 'N° do documento',
      validDocument: 'Insira um CPF válido.',
      documentNotRegister: 'Documento não condiz com o registro.',
      accessReport: 'Acessar resultado',
      documentType: 'Tipo de documento',

      goPortalPatient: 'Ir para o Portal do Paciente',
      expiredOrInvalid: 'Link inválido ou expirado.',
      youReports: 'Acesse o Portal do Paciente para visualizar todos os seus laudos.',
      portalPAtient: 'Portal do Paciente',

      donwloadApp: 'Ou baixe o aplicativo Hilab',
      redirect: 'Só um momento estamos redirecionando...',
      errorReport: 'Houve um erro ao carregar seu laudo.',
      verifyConnection: 'Verifique sua conexão e tente novamente.  Caso o erro persista, acesse o',
      contact: 'ou entre em contato com nosso atendimento:',
      UAU: 'UAU – Unidade de Atendimento ao Usuário / Paciente',
      CNS: 'CNS (Cartão nacional de saúde)',
      IssuingAgency: 'Órgão expedidor',
      state: 'Estado',
      
      country: 'País de origem',
      writeCountry: 'Digite o país de origem',
      /* finish text report sms */

      Afghanistan: "Afeganistão",
      "South Africa": "África do Sul",
      Albania: "Albânia",
      Germany: "Alemanha",
      Andorra: "Andorra",
      Angola: "Angola",
      Anguilla: "Anguilla",
      Antarctic: "Antártida",
      "Antigua and Barbuda": "Antígua e Barbuda",
      "Saudi Arabia": "Arábia Saudita",
      Algeria: "Argélia",
      Argentina: "Argentina",
      Armenia: "Armênia",
      Aruba: "Aruba",
      Australia: "Austrália",
      Austria: "Áustria",
      Azerbaijan: "Azerbaijão",
      Bahamas: "Bahamas",
      Bahrain: "Bahrein",
      Bangladesh: "Bangladesh",
      Barbados: "Barbados",
      Belarus: "Belarus",
      Belgium: "Bélgica",
      Belize: "Belize",
      Benin: "Benin",
      Bermuda: "Bermudas",
      Bolivia: "Bolívia",
      "Bosnia Herzegovina": "Bósnia-Herzegóvina",
      Botswana: "Botsuana",
      Brazil: "Brasil",
      Brunei: "Brunei",
      Bulgaria: "Bulgária",
      "Burkina fasso": "Burkina fasso",
      Burundi: "Burundi",
      Bhutan: "Butão",
      "Cape Green": "Cabo verde",
      Cameroon: "Camarões",
      Cambodia: "Camboja",
      Canada: "Canadá",
      Canary: "Canárias",
      Kazakhstan: "Cazaquistão",
      "Ceuta and Melilla": "Ceuta e Melilla",
      Chad: "Chade",
      Chile: "Chile",
      China: "China",
      Cyprus: "Chipre",
      Singapore: "Cingapura",
      Colombia: "Colômbia",
      Consisting: "Comores",
      Congo: "Congo",
      "North Korea": "Coréia do Norte",
      "South Korea": "Coréia do Sul",
      "Costa do Marfim": "Costa do Marfim",
      "Costa Rica": "Costa Rica",
      Croatia: "Croácia",
      Cuba: "Cuba",
      Cure: "Curaçao",
      "Diego Garcia": "Diego garcia",
      Denmark: "Dinamarca",
      Djibouti: "Djibuti",
      Dominica: "Dominica",
      Egypt: "Egito",
      "El Salvador": "El Salvador",
      "United Arab Emirates": "Emiratos Árabes Unidos",
      Ecuador: "Equador",
      Erythrean: "Eritréia",
      Slovakia: "Eslováquia",
      Slovenia: "Eslovênia",
      Spain: "Espanha",
      "U.S": "Estados Unidos",
      Estonia: "Estônia",
      Ethiopia: "Etiópia",
      Fiji: "Fiji",
      Philippines: "Filipinas",
      Finland: "Finlândia",
      France: "França",
      Gabon: "Gabão",
      Gambia: "Gambia",
      Ghana: "Gana",
      Georgia: "Geórgia",
      Gibraltar: "Gibraltar",
      "Britain (United Kingdom, UK)": "Grã-Bretanha (Reino Unido, UK)",
      Grenade: "Granada",
      Greece: "Grécia",
      Gyroon: "Groelândia",
      Guadalupe: "Guadalupe",
      "Guam (United States Territory)":
        "Guam (Território dos Estados Unidos)",
      Guatemala: "Guatemala",
      Guernsey: "Guernsey",
      Guyana: "Guiana",
      "French Guiana": "Guiana Francesa",
      Guinea: "Guiné",
      "Equatorial Guinea": "Guiné Equatorial",
      "Guinea Bissau": "Guiné-Bissau",
      Haiti: "Haití",
      Netherlands: "Países baixos",
      Honduras: "Honduras",
      "Hong Kong": "Hong Kong",
      Hungary: "Hungría",
      Yemen: "Iêmen",
      Bouvet: "Bronco",
      Rise: "Subir",
      "Clipperton Island": "Isla de Clipperton",
      Island: "isla",
      "Christmas island": "Ilha Natal",
      Pitcair: "Pitcair",
      "Island meeting": "Ilha Reunião",
      "Aland Islands": "Ilhas Aland",
      "Cayman Islands": "Ilhas Cayman",
      "Coconut islands": "Ilhas Coco",
      "Cook Islands": "Ilhas Cook",
      "Faroe Islands": "Ilhas Faroes",
      "South Georgia Islands and South Sandwich":
        "Ilhas Geórgia do Sul e Sandwich do Sul",
      "Heard and McDonald Islands (Australia Territory)":
        "Ilhas Heard e McDonald (Território da Austrália)",
      Malvinas: "Malvinas",
      "Northern Mariana Islands": "Ilhas Marianas do Norte",
      "Marshall Islands": "Ilhas Marshall",
      "Smaller islands of the United States":
        "Ilhas Menores dos Estados Unidos.",
      "Norfolk Islands": "Ilhas Norfolk",
      "Solomon Islands": "Ilhas Salomão",
      "Seychelles Islands": "Ilhas Seychelles",
      "Tokelau Islands": "Ilhas Tokelau",
      "Turks and Caicos Islands": "Ilhas Turks e Caicos",
      "Virgin Islands (United States)": "Ilhas Virgens (Estados Unidos)",
      "Virgin Islands (England)": "Ilhas Virgens (Inglaterra)",
      India: "India",
      Indonesia: "Indonesia",
      Will: "Voluntad",
      Iran: "Irã",
      Iraq: "Iraque",
      Ireland: "Irlanda",
      Iceland: "Islandia",
      Israel: "Israel",
      Italy: "Italia",
      Jamaica: "Jamaica",
      Japan: "Japão",
      Jersey: "Jersey",
      Jordan: "Jordânia",
      Kiribati: "Kiribati",
      Kosovo: "Kosovo",
      Kuait: "Kuait",
      Laos: "Laos",
      Lesotho: "Lesoto",
      Latvia: "Letonia",
      Lebanon: "Líbano",
      Liberia: "Liberia",
      Libya: "Libia",
      Liechtenstein: "Liechtenstein",
      Lithuania: "Lituania",
      Luxembourg: "Luxemburgo",
      Macao: "Macau",
      "Macedonia (Yugoslava Republic)": "Macedonia (República Yugoslava)",
      Madagascar: "Madagascar",
      Malaysia: "Malasia",
      Malawi: "Malawi",
      Maldives: "Maldivas",
      Mali: "Mali",
      Malta: "Malta",
      Morocco: "Marrocos",
      Martinique: "Martinica",
      Maurician: "Mauricio",
      Mauritania: "Mauritania",
      Mayotte: "Mayotte",
      Mexico: "México",
      Micronesia: "Micronésia",
      Mozambique: "Moçambique",
      Moldovate: "Moldova",
      Monkey: "Mônaco",
      Mongolia: "Mongolia",
      Montenegro: "Montenegro",
      Montserrat: "Montserrat",
      Myanma: "Myanma",
      Namibia: "Namibia",
      Nauru: "Nauru",
      Nepal: "Nepal",
      Nicaragua: "Nicarágua",
      Niger: "Níger",
      Nigeria: "Nigéria",
      Niue: "Niue",
      Norway: "Noruega",
      "New Caledonia": "Nova Caledonia",
      "New Zealand": "Nova Zelanda",
      Oman: "Omã",
      "Caribbean Netherlands": "Países Baixos Caribenhos",
      Palau: "Palau",
      Palestine: "Palestina",
      Panama: "Panamá",
      "Papua New Guinea": "Papua-Nova Guiné",
      Pakistan: "Paquistão",
      Paraguay: "Paraguai",
      Peru: "Peru",
      "French Polynesian": "Polinésia Francesa",
      Poland: "Polônia",
      "Puerto Rico": "Porto Rico",
      Portugal: "Portugal",
      Qatar: "Qatar",
      Kenya: "Quênia",
      Kyrgyzstan: "Quirguistão",
      "Central African Republic": "República Centro-Africana",
      "Democratic Republic of Congo": "República Democrática do Congo",
      "Dominican Republic": "República Dominicana",
      "Czech republic": "República Tcheca",
      Romania: "Romênia",
      Rwanda: "Ruanda",
      "Russia (former USSR) - Russian Federation":
        "Rússia (antiga URSS) - Federação Russa",
      Western: "occidental",
      "Saint-Pierre and Miquelon": "Saint-Pierre e Miquelon",
      "American Samoa": "Samoa Americana",
      "Western samoa": "Samoa Ocidental",
      "San Marino": "Santa Marino",
      "Saint Helen": "Santa Helena",
      "Santa lúcia": "Santa Lucía",
      "São Bartolomeu": "São Bartolomeu",
      "Saint Kitts and Nevis": "São Cristóvão e Névis",
      "São Martim": "São Martim",
      "São Martinho": "São Martinho",
      "Sao Tome and Principe": "São Tomé e Príncipe",
      "Saint Vincent and the Grenadines": "São Vicente e Granadinas",
      Senegal: "Senegal",
      "Sierra Leone": "Serra Leoa",
      Serbia: "Sérvia",
      Syria: "Síria",
      Somalia: "Somália",
      "Sri Lanka": "Sri Lanka",
      Swaziland: "Suazilândia",
      Sudan: "Sudão",
      "Southern Sudan": "Sudão do Sul",
      Sweden: "Suécia",
      Switzerland: "Suíça",
      Suriname: "Suriname",
      Svalbard: "Svalbard",
      Tajikistan: "Tadjiquistão",
      Thailand: "Tailândia",
      Taiwan: "Taiwan",
      Tanzania: "Tanzânia",
      "British Indian Ocean Territory":
        "Território Britânico do Oceano índico",
      "Territories from the south of France": "Territórios do Sul da França",
      "Timor-Leste": "Timor-Leste",
      Togo: "Togo",
      Tonga: "Tonga",
      "Trinidad and Tobago": "Trinidad e Tobago",
      "Tristão da Cunha": "Tristão da cunha",
      Tunisia: "Tunísia",
      Turkmenistan: "Turcomenistão",
      Turkey: "Turquia",
      Tuvalu: "Tuvalu",
      Ukraine: "Ucrânia",
      Uganda: "Uganda",
      Uruguay: "Uruguai",
      Uzbekistan: "Uzbequistão",
      Vanuatu: "Vanuatu",
      Vatican: "Vaticano",
      Venezuela: "Venezuela",
      Vietnam: "Vietnã",
      "Wallis and Futuna": "Wallis e Futuna",
      Zambia: "Zâmbia",
      Zimbabwe: "Zimbábue",
      showInfoText: "Esta imagem equivale a um demonstrativo do seu resultado, <b>não é válida como documento oficial</b>, para obter seu laudo, clique no botão abaixo.",
      yourResult: "SEU RESULTADO É",
      coronavirus: "Coronavírus"
    },
  },
};

export default translation;
